/**
 *
 * @name app.core.layout.view.header.events.CoreHeaderEvents
 * @copyright 2015 Empower Retirement
 * @description
 *
 *  These are the events for the header
 */

"use strict";

var root = "CoreHeaderEvent.";

var HeaderEvents = {
    LOGOUT: root + "logout_clicked_event",
    MAIN_TOGGLE: root + "main_nav_menu_toggled_event",
    GUIDANCE: root + "guidance_link_clicked_event",
    BENEFICIARY: root + "add_a_beneficiary_link_clicked_event",
    MANAGED: root + "jp_managed_link_clicked_event",
    PROFILE: root + "profile_link_clicked_event",
    ACCOUNT: root + "account_dropdown_clicked_event",
    ACCOUNT_DROPDOWN_MENU: root + "account_dropdown_menu_clicked_event"
};

/**
 * Publish constructor array.
 */
export default HeaderEvents;
